export const OPEN_PRODUCT_START = 'OPEN_PRODUCT_START';

export const CLEAR_PRODUCT_START = 'CLEAR_PRODUCT_START';
